import { memoryStore, useStore } from "../../lib/store";
import RoomExplainerBottomSheet from "./RoomExplainerBottomSheet";

// The room whose information is on screen, if any. One at a time: a second
// open replaces it.
const roomInfoStore = memoryStore<string | null>(null);

/**
 * Opens what a room is, with its contact line (docs/partner-objection.md,
 * Figma D3, 5153:35160), over whatever page the reader is on: from the ⓘ of
 * the room's attribution. The same sheet as on a phone, in a dialog. A join
 * opens the welcome of `RoomWelcomeHost`.
 */
function openDesktopRoomInfo(roomId: string): void {
  roomInfoStore.set(roomId);
}

/**
 * Renders the room information `openDesktopRoomInfo` asked for. Mounted once,
 * by the desktop shell.
 */
function DesktopRoomInfoHost(): React.JSX.Element | null {
  const [roomId, setRoomId] = useStore(roomInfoStore);
  if (roomId === null) return null;
  return (
    <RoomExplainerBottomSheet
      roomId={roomId}
      presentation="dialog"
      isOpen
      onClose={() => {
        setRoomId(null);
      }}
    />
  );
}

export { DesktopRoomInfoHost, openDesktopRoomInfo };
